import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
import { useContextSelector } from "use-context-selector";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import useScrollToItem from "../../component/Scroll";
import AuthContext from "../../context/AuthContext";
import BetSlipContext from "../../context/BetSlipContext";
const useHomeSelectionLogic = ({ object, matchOdds }) => {
  // 🔹 Context
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  const oneClickBid = useContextSelector(AuthContext, (ctx) => ctx.oneClickBid);
  const oneclickActive = useContextSelector(
    AuthContext,
    (ctx) => ctx.oneclickActive,
  );
  const betSlipObject = useContextSelector(
    BetSlipContext,
    (ctx) => ctx.betSlipObject,
  );
  const showBetDialog = useContextSelector(
    BetSlipContext,
    (ctx) => ctx.showBetDialog,
  );
  const betPlace = useContextSelector(BetSlipContext, (ctx) => ctx.betPlace);

  const setToastObject = useContextSelector(
    BetSlipContext,
    (ctx) => ctx.setToastObject,
  );
  const setBetSlipObject = useContextSelector(
    BetSlipContext,
    (ctx) => ctx.setBetSlipObject,
  );
  const handelPlaceBetFair = useContextSelector(
    BetSlipContext,
    (ctx) => ctx.handelPlaceBetFair,
  );
  const setLimit = useContextSelector(BetSlipContext, (ctx) => ctx.setLimit);
  const setShowBetDialog = useContextSelector(
    BetSlipContext,
    (ctx) => ctx.setShowBetDialog,
  );
  const setOneClickBetLoader = useContextSelector(
    BetSlipContext,
    (ctx) => ctx.setOneClickBetLoader,
  );

  // 🔹 State
  const [runner, setRunner] = useState([]);
  const [position, setPosition] = useState([]);
  const [localLimit, setLocalLimit] = useState({
    minAmount: 10,
    maxAmount: 100,
    oddsLimit: 100,
  });

  const navigate = useNavigate();
  const scrollToItem = useScrollToItem("#header");

  // 🔹 Load bet limits
  useEffect(() => {
    let obj = profileData?.matchSetting?.find(
      (res) => res?.type === "betFaire" && res?.sportType === object?.gameType,
    );
    if (!isEmpty(object?.betLimitSetting)) {
      setLocalLimit(
        !isEmpty(obj)
          ? {
              ...obj,
              minAmount: object?.betLimitSetting?.minBet,
              maxAmount: object?.betLimitSetting?.maxBet,
            }
          : { minAmount: 10, maxAmount: 100, oddsLimit: 50 },
      );
    } else if (!isEmpty(profileData)) {
      setLocalLimit(
        !isEmpty(obj) ? obj : { minAmount: 10, maxAmount: 100, oddsLimit: 50 },
      );
    }
  }, [profileData, object]);
  // 🔹 Fetch bet positions
  const getBetPosition = useCallback(async (item) => {
    const { status, data: response_users } = await apiGet(
      `${apiPath.betPosition}?marketId=${item?.marketId}&eventId=${item?.eventId}`,
    );
    if (response_users.success) {
      setPosition(response_users?.results);
      setRunner((current) =>
        response_users?.results?.betFair?.length > 0
          ? current.map((res) => {
              const obj = response_users?.results?.betFair?.find(
                (i) => i?.selectionId == res?.SelectionId,
              );
              return {
                ...res,
                position: obj ? obj?.position : 0,
                newPosition: 0,
              };
            })
          : current.map((res) => ({
              ...res,
              position: 0,
              newPosition: 0,
            })),
      );
    }
  }, []);
  // 🔹 Handle bet click
  const handelChange = (odds, type, team, item, e) => {
    if (isEmpty(user)) {
      setToastObject({
        type: "warning",
        title: "Warning",
        message: "Please login to place your bet!",
        status: true,
      });
      return;
    }

    if (odds?.rt > 0) {
      setShowBetDialog(true);

      scrollToItem(e.currentTarget);

      let obj = {
        odds: odds?.rt,
        teamName: team,
        betType: type,
        playType: "home",
        newMarketId: object?.marketId,
        object: {
          ...item,
          ...odds,
          teamName: team,
          eventId: object?.eventId,
          marketId: object?.marketId,
          newMarketId: object?.marketId,
        },
      };

      // if (oneclickActive) {
      //   setOneClickBetLoader("betfair");
      //   handelPlaceBetFair(localLimit, { ...obj, bidPrice: oneClickBid });
      // }

      setLimit(localLimit);
      setBetSlipObject((prev) => ({ ...prev, ...obj }));
    }
  };

  // 🔹 Update bet positions (preview mode before placing)
  const handelBetFairPositions = useCallback(
    (slipObj) => {
      let selectionsTemp = [...runner];
      if (!(betSlipObject?.bidPrice > 0)) return;

      if (slipObj?.object?.ib) {
        // Back bet
        let backProfit = (betSlipObject.odds - 1) * betSlipObject?.bidPrice;
        let backLoss = betSlipObject?.bidPrice;

        setRunner(
          selectionsTemp.map((rl) =>
            rl.SelectionId === slipObj?.object?.ri
              ? { ...rl, newPosition: Number(rl.position) + backProfit }
              : { ...rl, newPosition: Number(rl.position) - backLoss },
          ),
        );
      } else {
        // Lay bet
        let backProfit = betSlipObject?.bidPrice;
        let backLoss = (betSlipObject.odds - 1) * betSlipObject?.bidPrice;

        setRunner(
          selectionsTemp.map((rl) =>
            rl.SelectionId === slipObj?.object?.ri
              ? { ...rl, newPosition: Number(rl.position) - backLoss }
              : { ...rl, newPosition: Number(rl.position) + backProfit },
          ),
        );
      }
    },
    [runner, betSlipObject],
  );

  // 🔹 Auto-update preview when bet slip changes
  useEffect(() => {
    if (showBetDialog && betSlipObject?.playType === "home") {
      handelBetFairPositions(betSlipObject);
    }
  }, [betSlipObject, showBetDialog]);

  // 🔹 Initialize runners + fetch positions if logged in
  useEffect(() => {
    setRunner(object?.runners || []);
    if (!isEmpty(user)) {
      getBetPosition(object);
    }
  }, [user, object]);

  // 🔹 Refresh positions on bet placement success
  useEffect(() => {
    if (betPlace?.isPlaced && betPlace?.type === "matched") {
      getBetPosition(object);
    }
  }, [betPlace, object]);

  const isRtValid = useCallback((obj, limit) => {
    const { rt } = obj;
    if (rt === undefined || rt === null || rt === "" || rt === 0) return true;
    if (typeof rt === "number" && limit !== undefined) {
      return rt >= limit?.oddsLimit;
    }
    return false;
  }, []);

  const checkArrays = (arr1, arr2, limit) => {
    const combined = [...(arr1 || []), ...(arr2 || [])];
    return combined.length > 0
      ? combined.every((obj) => isRtValid(obj, limit))
      : true;
  };

  return {
    runner,
    position,
    localLimit,
    handelChange,
    getBetPosition,
    isRtValid,
    checkArrays,
    betSlipObject,
    showBetDialog,
  };
};

export default useHomeSelectionLogic;
